import {useState} from "react";

export const useIsComparing = () => {
    const [isComparing, setIsComparing] = useState(false);
    const startComparing = (e) => {
        setIsComparing(true);
    };
    const stopComparing = () => {
        setIsComparing(false);
    };
    return { isComparing, startComparing, stopComparing };
};
